// Tipos espelhando os DTOs C# em WiserTalk.Shared.DTOs.Chatbot
// Mantenha em sync manual com:
//   - src/WiserTalk.Shared/Enums/FlowNodeType.cs
//   - src/WiserTalk.Shared/DTOs/Chatbot/FlowNodeDto.cs
//   - src/WiserTalk.Shared/DTOs/Chatbot/FlowEdgeDto.cs
//   - src/WiserTalk.Shared/DTOs/Chatbot/FlowDefinitionDto.cs

export const FlowNodeType = {
  Start: 0,
  SendMessage: 1,
  AskQuestion: 2,
  Menu: 3,
  Condition: 4,
  AiAgent: 5,
  TransferToQueue: 6,
  SetTag: 7,
  SetCategory: 8,
  Webhook: 9,
  Wait: 10,
  End: 11,
  TriggerNewConversation: 12,
  TriggerKeyword: 13,
  TransferToAgent: 14,
  TriggerEmailReceived: 15,
  WaitForReply: 16,
  ResolveTicket: 17,
} as const;

export type FlowNodeTypeValue = typeof FlowNodeType[keyof typeof FlowNodeType];

export interface FlowNodeDto {
  id: string;            // Guid
  type: FlowNodeTypeValue;
  positionX: number;
  positionY: number;
  config: string;        // JSON string
}

export interface FlowEdgeDto {
  id: string;            // Guid
  sourceNodeId: string;  // Guid
  targetNodeId: string;  // Guid
  condition: string | null; // JSON string ex: '{"value":"opt2"}'
}

export interface FlowDto {
  id: string;
  name: string;
  description?: string | null;
  channelId?: string | null;
  channelName?: string | null;
  isActive: boolean;
  version: number;
}

export interface FlowDefinitionDto {
  flow: FlowDto;
  nodes: FlowNodeDto[];
  edges: FlowEdgeDto[];
}

// Lookup option (para selects no PropertiesPanel — fila, equipe, categoria, tag).
export interface LookupOption {
  id: string;
  name: string;
}

// Lookup de agente — extends LookupOption com queueIds para filtragem por fila upstream.
export interface AgentLookup {
  id: string;
  name: string;
  queueIds: string[];
}

// Bundle de lookups passado pelo Blazor na inicialização.
export interface EditorLookups {
  queues: LookupOption[];
  teams: LookupOption[];
  tags: LookupOption[];
  categories: LookupOption[];
  agents: AgentLookup[];
}

// Interface do DotNetObjectReference que o Blazor passa pra cá.
// Métodos correspondem aos [JSInvokable] em FlowEditorHost.razor.cs.
export interface DotNetRef {
  invokeMethodAsync(methodName: 'OnSelectionChangedCallback', nodeId: string | null): Promise<void>;
  invokeMethodAsync(methodName: 'OnChangedCallback'): Promise<void>;
}
